import {LoginCallback, SecureRoute} from "@okta/okta-react";
import {Redirect, Route, Switch} from "react-router-dom";
import {LoadingSpinner} from "./components/common/LoadingSpinner";
import useUserGuiding from "./hooks/useUserGuiding";
import WhoAmIView from "./views/WhoAmIView";
import UnassignedJobsViewContainer from "./views/UnassignedJobsViewContainer";
import SettingsViewContainer from "./views/SettingsViewContainer";
import React from "react";
import RoutePlanningViewContainer from "./views/RoutePlanningViewContainer";
import "./App.css";
import AssignedStopsViewContainer from "./views/AssignedStopsViewContainer";

const CustomLoginCallback = () => {
  return <LoginCallback loadingElement={<LoadingSpinner />} />;
};

const AppRoutes = () => {
  useUserGuiding();

  return (
    <Switch>
      <SecureRoute exact path="/">
        <Redirect to="/jobs" />
      </SecureRoute>
      <SecureRoute path="/whoami" component={WhoAmIView} />
      <SecureRoute path="/jobs" component={UnassignedJobsViewContainer} />
      <SecureRoute path="/assigned-stops" component={AssignedStopsViewContainer} />
      <SecureRoute path="/itinerary-planning" component={RoutePlanningViewContainer} />
      <SecureRoute path="/settings" component={SettingsViewContainer} />
      <Route path="/login/callback" component={CustomLoginCallback} />
    </Switch>
  );
};

export default AppRoutes;
